import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { inDevelopMode } from "utils/env"

import { configs } from "configs"
import { AUTH_TOKEN_COOKIE_KEY } from "constants/api"
import { getCookie } from "utils/cookie"
import { removeAppCredentials } from "configs/utils"
import { logout } from "./appSlice"
import { authApi } from "./api/authSlice"

const authHeader = auth => ({ token: auth ? auth : getCookie(AUTH_TOKEN_COOKIE_KEY) })

const getErrorFromResponse = response => {
  console.error("Request Error: ", response)
  return {
    ...response,
    error: {
      status: response.error?.originalStatus || response.error?.status,
      // TODO:
      message:
        (response.error?.data?.errors?.[0]?.extra?.filename == "IncentivesErrorFile" &&
          response.error?.data?.errors?.[0]) ||
        response.error?.message ||
        response.error?.data?.message ||
        (response.error?.data?.errors && response.error.data.errors.map(e => `${e.message}`).join(", ")) ||
        response.error?.data ||
        "Network error",
    },
  }
}

const tagTypes = [
  "client-detail",
  "leads",
  "taskLogs",
  "sharings",
  "project-info",
  "clients",
  "kpi-reports",
  "meeting-list",
  "meeting-detail",
  "action-items",
  "project-detail",
  "qc-listing",
]

export const getHeaders = fingerPrint => {
  return {
    prepareHeaders: (headers, { getState }) => {
      let obj = {}
      const cookie = getCookie(AUTH_TOKEN_COOKIE_KEY)
      const stateToken = getState().app.auth.token || cookie
      if (stateToken && typeof stateToken !== "boolean") {
        obj = authHeader(stateToken)
      }
      Object.keys(obj).forEach(e => {
        !!obj[e] && headers.set(e, obj[e])
      })
      if (fingerPrint) {
        headers.set("x-di", fingerPrint)
      }
      headers.set("x-aff-p", configs.platformKey())
      return headers
    },
  }
}

const baseQuery = fingerPrint =>
  fetchBaseQuery({
    baseUrl: configs.apiBaseURL(),
    ...getHeaders(fingerPrint),
    credentials: inDevelopMode ? undefined : "include",
  })

const parentApi = createApi({
  reducerPath: "parentApi",
  baseQuery: async (args, api, extraOptions) => {
    try {
      let result = await baseQuery()(args, api, extraOptions)
      if (result.error) {
        if (result.error.status === 401 || result?.error?.originalStatus === 401) {
          removeAppCredentials(null, true)
          api.dispatch(logout(true))
          api.dispatch(authApi.util.resetApiState())
        } else {
          return getErrorFromResponse(result)
        }
      }
      console.log(result, "result")
      return result
    } catch (e) {
      return getErrorFromResponse(e)
    }
  },
  tagTypes,
  endpoints: builder => ({}),
})

export default parentApi
